export default {
  user: {
    username: null,
    email: null,
    oldPassword: null,
  },
  isAdmin: false,
  loggedIn: null,
};
